(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      // Fail closed: an unmeasured header must never look like "already scrolled past".
      this.headerBounds = { top: 0, bottom: Infinity, height: 0 };

      this.setHeaderHeight();
      this.measureHeaderBounds();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    // Re-measurable replacement for the single captured intersectionRect.
    // Returns false (and keeps the previous bounds) whenever the measurement
    // cannot be trusted, so a zero rect never becomes the scroll threshold.
    measureHeaderBounds() {
      const height = this.header.offsetHeight;

      // Zero height means the header is display:none or mid-layout.
      if (!height) return false;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let top = this.headerBounds.top;

      if (scrollTop === 0) {
        // Only at the top of the document does a position:sticky header report
        // its real document-flow offset; mid-scroll it reports the stuck rect.
        const rect = this.header.getBoundingClientRect();
        if (!rect.height) return false;
        top = rect.top;
      } else if (typeof top !== 'number' || !isFinite(top)) {
        top = 0;
      }

      this.headerBounds = { top: top, bottom: top + height, height: height };
      return true;
    }

    onResize() {
      window.clearTimeout(this.isResizing);
      this.isResizing = setTimeout(() => {
        this.setHeaderHeight();
        this.measureHeaderBounds();
      }, 150);
    }

    // Single toggle point for the class that resizes the logo. Guarded so the
    // class is only ever added when absent and removed when present, and the
    // header height / bounds are refreshed once per real transition.
    setScrolledPastHeader(shouldBeSet) {
      const isSet = this.header.classList.contains('scrolled-past-header');
      if (shouldBeSet === isSet) return;

      this.header.classList.toggle('scrolled-past-header', shouldBeSet);
      this.setHeaderHeight();
      this.measureHeaderBounds();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.clearTimeout(this.isResizing);
      if (this.headerObserver) this.headerObserver.disconnect();
    }

    createObserver() {
      // Stay connected and re-measure on every intersection change instead of
      // capturing one rect and disconnecting, which went stale as soon as the
      // logo shrank. measureHeaderBounds() rejects untrustworthy rects.
      this.headerObserver = new IntersectionObserver(() => {
        this.measureHeaderBounds();
      });

      this.headerObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledPastHeader(true);
        if (this.preventHide) return;
        if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledPastHeader(true);
        if (!this.preventReveal) {
          if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.setScrolledPastHeader(false);
        if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
